import { render, staticRenderFns } from "./ImportUpdateCus.vue?vue&type=template&id=543d60d6&"
import script from "./ImportUpdateCus.vue?vue&type=script&lang=js&"
export * from "./ImportUpdateCus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports